import { createSlice } from "@reduxjs/toolkit";

const initialState = [];

export const ScorecardReducer = createSlice({
    name: "ScorecardReducer",
    initialState,
    reducers: {
        setScorecard: (state, action) => {
            state.length = 0;
            action.payload.map(obj => {
                state.push(obj);
            });
        },
        updateScorecard: (state, action) => {
            let objIndex = state.findIndex(stateObj => {
                return (stateObj._id === action.payload._id) ;
            });

            if (objIndex >= 0) {
                state.splice(objIndex, 1, action.payload);
            } else if(objIndex === -1) {
                state.push(action.payload);
            }
        }
    }
});
export const {setScorecard, updateScorecard} = ScorecardReducer.actions;

export default ScorecardReducer.reducer;